// extracted by mini-css-extract-plugin
export var component = "ExternalArticleButton-module--component--5fd94";
export var fadePop = "ExternalArticleButton-module--fade-pop--af9cb";
export var growHeightIn = "ExternalArticleButton-module--grow-height-in--c7e23";
export var subtext = "ExternalArticleButton-module--subtext--d2f93";